<script setup>
import { computed, onMounted } from 'vue';

const emit = defineEmits(['onClick']);
const { content = '', visible = false } = defineProps({
  content: String,
  visible: Boolean,
});

const position = computed(() => {
  const anchor = document.querySelector('.info-bubble-anchor');
  if (!anchor) return null;
  return { x: anchor.getBoundingClientRect().left, y: anchor.getBoundingClientRect().top };
});

const handleClick = () => {
  emit('onClick');
};
</script>

<template>
  <Transition name="popup">
    <div v-if="visible" class="help-bubble" :style="{ left: position?.x - 8 + 'px', top: position?.y + 30 + 'px' }">
      <div class="content" v-html="content"></div>
      <button class="help-button" @click="handleClick"><span>Fermer</span></button>
    </div>
  </Transition>
</template>

<style scoped lang="scss">
.help-bubble {
  max-width: 221px;
  position: fixed;
  z-index: 1;
  padding: 16px;
  background-color: #333333;
  border-radius: 5px;
  color: white;
  gap: 12px;

  &::after {
    content: '';
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 8px solid #333333;
    position: absolute;
    top: -5px;
    left: 12px;
  }

  .content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;

    :deep(h1),
    :deep(h2) {
      padding: 0;
      margin: 0;
    }

    :deep(h1) {
      font-weight: 700;
      text-transform: uppercase;
      font-size: 0.8rem;
    }

    :deep(h2) {
      font-weight: 700;
      font-size: 0.76rem;
      font-family: Mulish, sans-serif;
    }

    :deep(b) {
      font-weight: bold;
    }

    :deep(span) {
      font-family: Mulish, sans-serif;
      font-weight: 300;
      font-size: 0.76rem;

      > ul {
        padding-left: 20px;
      }
    }
  }

  .help-button {
    position: relative;
    width: 100%;
    height: 30px;
    border: 1px solid white;
    border-radius: 5px;
    background: none;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 11px;
    font-family: Lato, sans-serif;
    cursor: pointer;
    margin-top: 12px;
    overflow: hidden;

    &:after {
      content: '';
      position: absolute;
      inset: 0 -5%;
      background-color: white;
      opacity: 0.2;
      transition-duration: 0.2s;
      transform: translateX(-100%) skew(10deg);
    }

    &:hover {
      &:after {
        transform: translateX(0) skew(10deg);
      }
    }

    &:active {
      font-size: 10px;
    }
  }
}
</style>
